import { SelectInput, TextInput, ReferenceInput, required, FormDataConsumer } from 'react-admin';
import { state, onlyNum, cpf, crm } from '../../../normalize';
import selectValues from '../../../constants/selectValues';
import typeDocumentChoice from '../../../constants/choices/typeDocumentChoice';

const widthInputs = { width: '260px' };
const validateRequired = required();

const isProdEnvironment = () => process.env.NODE_ENV === 'production';

const TYPE_USER_CRM = typeDocumentChoice.find(type => type.name === 'CRM')?.id;
const UF_RJ = 'RJ';


const UserPersonalData = ({ edit }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <label style={{ fontWeight: 'bold', marginBottom: '16px' }}>Dados pessoais</label>
    <SelectInput
      style={widthInputs}
      label="Tratamento"
      source="genderUser.id"
      choices={[
        { id: 0, name: 'DR.' },
        { id: 1, name: 'DRA.' },
      ]}
      validate={validateRequired}
    />
    <TextInput
      style={widthInputs}
      label="Nome"
      source="name"
      validate={validateRequired}
      resettable
    />
    <TextInput
      style={widthInputs}
      label="Sobrenome"
      source="lastName"
      validate={validateRequired}
      resettable
    />
    <ReferenceInput
      sort={{ field: 'name', order: 'ASC' }}
      perPage={999}
      resource="typeUser.id"
      source={edit ? 'typeUser.id' : 'typeUser'}
      reference="type-users"
    >
      <SelectInput
        style={widthInputs}
        validate={validateRequired}
        label="Tipos de Usuário"
        optionText="type"
        optionValue="id"
      />
    </ReferenceInput>
    <FormDataConsumer>
      {({ formData }) => {
        if (edit) {
          const ufValue = formData?.UF || '';
          let docNumberValue = formData?.documentNumber || '';

          const isCrmRj = (formData?.typeUser?.id === TYPE_USER_CRM || formData?.typeUser === TYPE_USER_CRM) && ufValue === UF_RJ;

          let inputValue = docNumberValue;
          if (isCrmRj && inputValue.startsWith('52')) {
            inputValue = inputValue.slice(2);
          }

          const documentInput = (
            <TextInput
              style={{ width: isCrmRj ? '145px' : '175px' }}
              label="Documento"
              source="documentNumber"
              validate={validateRequired}
              parse={value => onlyNum(value)}
              format={value => value || ''}
              defaultValue={inputValue}
              resettable
            />
          );

          return (
            <div style={{ display: 'flex', gap: '15px', width: '260px' }}>
              <SelectInput
                sx={{ width: '70px', minWidth: '70px' }}
                label="UF"
                source="UF"
                validate={validateRequired}
                parse={state}
                defaultValue={ufValue}
                choices={
                  isProdEnvironment()
                    ? selectValues.states.map(state => ({ id: state, name: state }))
                    : selectValues.states.concat('RX').map(state => ({ id: state, name: state }))
                }
              />
              {isCrmRj ? (
                <div style={{ display: 'flex', alignItems: 'center', width: '175px', gap: '4px' }}>
                  <TextInput
                    style={{ width: '47px'}}
                    label=""
                    source="crmPrefix"
                    defaultValue="52"
                    disabled
                  />
                  {documentInput}
                </div>
              ) : (
                documentInput
              )}
            </div>
          );
        }
        return (
          <TextInput
            style={widthInputs}
            placeholder='ex: SP1234'
            label="Documento"
            source="document"
            validate={validateRequired}
            parse={crm}
            resettable
          />
        );
      }}
    </FormDataConsumer>
    <TextInput
      style={widthInputs}
      placeholder="ex: 111.111.111-11"
      label="CPF"
      source="cpf"
      validate={validateRequired}
      parse={cpf}
      resettable
    />
  </div>
);

export default UserPersonalData;
